import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import RangeSliderField from 'components/FormControls/RangeSliderField';
import { searchOffices, setTimeFilter } from 'redux/modules/shop/offices';
import moment = require('moment');
const { connect } = require('react-redux');

interface IProps {
	t?: (key: string) => string;
	onChange?: ({ min, max }: { min: number; max: number }) => void;
	filterFrom?: number;
	filterTo?: number;
	resetAppliedFilters?: boolean;
	setResetAppliedFilters?: React.Dispatch<React.SetStateAction<boolean>>;
	displayOnlyRangeSlider?: boolean;
	setTimeFilter?: (timeFilter: { openTime?: number; closeTime?: number; utcOffset: number }) => void;
}

@connect(
	() => ({}),
	(dispatch) => ({
		setTimeFilter: (timeFilter: { openTime?: number; closeTime?: number; utcOffset: number }) =>
			dispatch(setTimeFilter(timeFilter)),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class HoursFilter extends React.Component<IProps> {
	constructor(props) {
		super(props);
	}

	render() {
		const {
			onChange,
			setTimeFilter,
			t,
			resetAppliedFilters,
			setResetAppliedFilters,
			displayOnlyRangeSlider,
			filterFrom,
			filterTo,
		} = this.props;
		////////////////////////////////////////////////////////////////////////
		// Store changes into redux
		////////////////////////////////////////////////////////////////////////
		const onChangeModified = ({ min, max }: { min: number; max: number }) => {
			if (onChange) {
				const newMin = min !== 0 ? min / 60 : null;
				const newMax = max !== 1440 ? max / 60 : null;

				onChange({ min: newMin, max: newMax });
			}

			if (min !== 0 || max !== 1440) {
				setTimeFilter({ openTime: min, closeTime: max, utcOffset: moment().utcOffset() });
			}

			if (min === 0 && max === 1440) {
				setTimeFilter(null);
			}

			searchOffices(true, true);
		};
		////////////////////////////////////////////////////////////////////////
		// Custom timepicker
		////////////////////////////////////////////////////////////////////////
		const convertValueToDisplayValue = (value: number): string => {
			const hours = Math.floor(value / 60);
			const minutes = value - hours * 60;
			return String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0');
		};
		////////////////////////////////////////////////////////////////////////
		return (
			<>
				<RangeSliderField
					input={{
						placeholder: t('BookAppointment_Schedule_Filter_Time'),
					}}
					className={c.SHOPS_HOURS_FILTER}
					onChange={onChangeModified}
					iconName="clock"
					minValue={0}
					maxValue={1440} // 24h x 60min
					filterFrom={filterFrom}
					filterTo={filterTo}
					resetAppliedFilters={resetAppliedFilters}
					setResetAppliedFilters={setResetAppliedFilters}
					customMinDisplayValueFunction={convertValueToDisplayValue}
					customMaxDisplayValueFunction={convertValueToDisplayValue}
					highlightWhenValueSet={true}
					displayOnlyRangeSlider={displayOnlyRangeSlider}
				/>
			</>
		);
	}
}

export default HoursFilter;
